const QUERY_KEYS_TO_IGNORE = ['dataNotSet', 'shouldSearch', 'search_term'];
const builFilterObject = ({
  queryKey,
  value,
  filters,
  isRange,
  isInQuery
}) => {
  if (isRange) {
    // don't add to query if value matches range values
    if (isInQuery || value.min !== value.minValue && value.max !== value.maxValue) {
      filters.push({
        range: {
          [queryKey]: {
            gte: Number(value.minValue),
            lte: Number(value.maxValue)
          }
        }
      });
    }
    return;
  }
  const key = isRange ? queryKey : `${queryKey}.keyword`;
  const isArray = Array.isArray(value);
  if (!isArray) {
    const singleFilterObj = {
      match: {
        [key]: value
      }
    };
    filters.push(singleFilterObj);
    return;
  }
  value.forEach(filterValue => {
    filters.push({
      match: {
        [key]: filterValue
      }
    });
  });
};
const buildFiltersQuery = ({
  shouldAddFilters,
  filterBy,
  filterByProperty,
  rangeValues,
  queryKeys,
  query
}) => {
  const mustFilters = [];
  if (shouldAddFilters && query) {
    Object.keys(query).forEach(queryKey => {
      if (QUERY_KEYS_TO_IGNORE.includes(queryKey)) return;
      if (!queryKey || !query[queryKey]) return;
      const queryValue = query[queryKey];
      const isRange = rangeValues.includes(queryKey);
      const isInQuery = queryKeys.includes(queryKey);
      builFilterObject({
        queryKey,
        value: queryValue,
        filters: mustFilters,
        isRange,
        isInQuery
      });
    });
  }
  if (filterByProperty && filterByProperty.length) {
    filterByProperty.forEach(filterByPropOption => {
      const [filterByPropKey] = filterByPropOption.split('/');
      filterBy.forEach(filterByOption => {
        if (filterByOption.indexOf(filterByPropKey) === -1) return;
        const [, filteryByValue] = filterByOption.split('/');
        const filterByKeyword = `${filterByPropKey}.keyword`;
        if (!filteryByValue) return;
        mustFilters.push({
          match: {
            [filterByKeyword]: filteryByValue
          }
        });
      });
    });
  }
  return mustFilters;
};
export default buildFiltersQuery;
//# sourceMappingURL=build-filters-query.js.map